var DeliveryOptions = (function (CheckoutApiCollection, CheckoutApiModel) {

    var _ourpaySelectServiceID = 'OURPAYSELECT';

    var deliveryAddressID = null;

    var packageID = null;

    var _eventHandler = $({});

    var _setDeliveryOption = function (_api, data, _updateCheckout) {
        
        return _api.setDeliveryOption(data)
            .done(function(data) {
                _updateCheckout(data);
                _eventHandler.trigger('deliveryOptionChanged');
            });
    }

    var OurPaySelectPackage = Backbone.Model.extend({

        idAttribute: 'ID',

        defaults: {
            ID: '',
            Name: '',
            Amount: 0,
            Selected: false
        },

        initialize: function () {
            _.bindAll(this, 'select');
        },

        select: function () {
            this.set('Selected', true);
        }
    });

    var OurPaySelectPackages = CheckoutApiCollection.extend({
        model: OurPaySelectPackage,

        initialize: function () {
            _.bindAll(this, '_init', 'setCurrentPackage');
            this._xhr = this._api.getDeliveryServicePackageDetails()
                .done(this._init);
        },

        _init: function (data) {
            this.update(data.Value);
            this.setCurrentPackage();
        },

        setCurrentPackage: function () {
            this.keepsilent = true;
            if (packageID) {
                var model = this.get(packageID);
                model && model.select();
            }
            this.keepsilent = false;
        },

        ready: function (ex) {
            this._xhr.done(ex);
        }
    });

    var DeliveryOption = CheckoutApiModel.extend({
        idAttribute: 'PostServiceId',

        defaults: {
            Name: '',
            Title: '',
            Info: '',
            Description: '',
            DeliveryOptions: [],
            Price: 0,
            Selected: false,

            Purchased: false,
            Packages: null,
            OurPaySelect: false,
            AgreedWithTerms: null,

            IsVisible: true,
            IsDeleted: false
        },

        initialize: function () {
            _.bindAll(this, 'select', '_changePackage');
            this.set('OurPaySelect', this.id === _ourpaySelectServiceID);
            this._loadPackages();
        },

        _loadPackages: function () {
            if (this.id === _ourpaySelectServiceID && !this.get('Purchased')) {
                var packages = new OurPaySelectPackages();
                this.set('Packages', packages);
                this.listenTo(packages, 'change:Selected', this._changePackage);
            }
        },

        select: function () {
            this.set('Selected', true);
        },

        getData: function () {
            return _.omit(this.toJSON(), 'Packages', 'Purchased', 'IsDeleted');
        },

        getSelectedPackage: function () {
            var packages = this.get('Packages');
            return packages && packages.where({ Selected: true })[0] || null;
        },

        isOurpaySelect: function () {
            return this.id === _ourpaySelectServiceID;
        },

        _changePackage: function (model) {
            if (model.get('Selected')) {
                var packages = this.get('Packages');
                packages.each(function (m) {
                    m.set('Selected', m.id === model.id);
                });

                var data = {
                    deliveryAddressID: deliveryAddressID || null,
                    type: 'OurPaySelect',
                    servicepackagedetailid: model.id,
                    deliveryoption: JSON.stringify(this.getData())
                };

                !packages.keepsilent && _setDeliveryOption(this._api, data, this._updateCheckout);
            }
        },

        update: function (optionData) {
            var agreedWithTermsState = this.get('AgreedWithTerms');

            if (optionData.PostServiceId === 'OURPAYSELECT' && optionData.IsAvailable === false) {
                optionData.Description = "The products in your basket do not qualify for 'SELECT' discount deliveries.";
            }

            this.set({
                Price: optionData.Price,
                Selected: optionData.Selected,
                Purchased: optionData.Purchased,
                Title: optionData.Title,
                Info: optionData.Info,
                Description: optionData.Description,
                IsAvailable: optionData.IsAvailable,
                DeliveryServicePackageDetailID: optionData.DeliveryServicePackageDetailID,
                AgreedWithTerms: agreedWithTermsState == null ? optionData.AgreedWithTerms : agreedWithTermsState
            });
        },
        setCurrentPackage: function () {
            var packages = this.get('Packages');
            packages && packages.setCurrentPackage();
        }
    });

    return CheckoutApiCollection.extend({
        model: DeliveryOption,

        initialize: function() {
            _.bindAll(this, 'update', '_selected', '_saved');
            this.on('change:Selected', this._selected);
            _eventHandler.on('deliveryOptionChanged', this._saved);
        },

        update: function(data) {
            this.keepsilent = true;
            deliveryAddressID = data.DeliveryAddress && data.DeliveryAddress.ID || null;
            packageID = data.DeliveryServicePackageDetail &&
                data.DeliveryServicePackageDetail.DeliveryServicePackageDetailID ||
                null;

            var ourpaySelectModel = this.get(_ourpaySelectServiceID);
            ourpaySelectModel && ourpaySelectModel.setCurrentPackage();

            var options = this._parse(_.clone(data.DeliveryOptions), data.DeliveryServicePackageDetail);

            /* Add/Update delivery options*/
            _.each(options,
                _.bind(function (option) {
                    if (option.PostServiceId == _ourpaySelectServiceID && data.OurPaySelect) {
                        option.AgreedWithTerms = data.OurPaySelect.TermsAndConditions == 2;
                    }

                    var model = this.get(option.PostServiceId);
                    model && model.update(option);
                    !model && this.add(options);
                    },
                    this));

            /* Remove absent options */
            this.each(_.bind(function(model) {
                    var option = _.findWhere(options, { PostServiceId: model.id });
                    model.set('IsDeleted', !option);
                },
                this));

            this.keepsilent = false;

            /* Select First option if current option isDeleted */
            var model = this.where({ Selected: true, IsDeleted: true })[0];
            model && this.first() && this.first().select();
        },

        _parse: function(options, packageDetail) {
            var allowOurpaySubscriptionForNewCustomer = false;
            
            if (options && options.length > 1) {
                return _.map(options, function (option) {
                    option.PostServiceId = (option.PostServiceId || option.DeliveryOptions[0]).toUpperCase();
                    option.Name = $.f['_DeliveryOption_' + option.DeliveryOptions[0] + '_Title'] || option.DeliveryOptions[0];
                    option.Description = $.f['_DeliveryOption_' + option.DeliveryOptions[0] + '_Description'] || '';

                    if (option.PostServiceId === _ourpaySelectServiceID) {
                        if(packageDetail && packageDetail.Purchased)
                        {
                            option.Description = kos.getPageTemplate('_Ops_description_remaining').replace(/\[\[Count\]\]/, packageDetail.CurrentCount);
                            option.Purchased = true;
                            option.DeliveryServicePackageDetailID = packageDetail.DeliveryServicePackageDetailID;
                        }
                        else if(!allowOurpaySubscriptionForNewCustomer)
                        {
                            option.IsVisible = false;
                        }
                    }
                    return option;
                });
            }
            return [];
        },

        _selected: function(model) {
            if (model.get('Selected')) {
                this.each(function(m) {
                    m.set('Selected', m.id === model.id);
                });

                var selectedPackageID = null;

                if (model.get('Purchased')) {
                    selectedPackageID = model.get('DeliveryServicePackageDetailID');
                } else {
                    var selectedPackage = model.getSelectedPackage();
                    selectedPackageID = selectedPackage && selectedPackage.id || null;
                }

                if (!this.isOurpaySelect() || selectedPackageID !== null)
                {
                    var data = {
                        deliveryAddressID: deliveryAddressID || null,
                        type: this.isOurpaySelect() && 'OurPaySelect' || '',
                        deliveryoption: JSON.stringify(model.getData()),
                        servicepackagedetailid: selectedPackageID
                    };

                    !this.keepsilent && _setDeliveryOption(this._api, data, this._updateCheckout);
                }
            }
        },

        _saved: function() {
            this.trigger('saved');  
        },

        deliveryType: function () {
            var model = this.where({ Selected: true })[0];
            return !!model ? model.id : 'STANDARD';
        },

        isOurpaySelect: function() {
            var model = this.where({ Selected: true })[0];
            return model && model.id === _ourpaySelectServiceID;
        },

        getOurpaySelectStatus: function() {
            var model = this.get(_ourpaySelectServiceID);
            return {
                available: model && model.get('IsAvailable'),
                selected: model && model.get('Selected')
            }
        },

        isValid: function() {
            var model = this.where({ Selected: true })[0];
            if (model && model.id === _ourpaySelectServiceID && !model.get('Purchased')) {
                return !!model.get('AgreedWithTerms');
            }
            return true;
        }
    });
})(CheckoutApiCollection, CheckoutApiModel);